import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './translations/translation_en.json';
import translationES from './translations/translation_es.json';
import translationFR from './translations/translation_fr.json';
import translationFR_BE from './translations/translation_fr-BE.json';
import translationRO from './translations/translation_ro.json';
import translationTH from './translations/translation_th.json';
import translationVI from './translations/translation_vi.json';
import translationNL from './translations/translation_nl.json';

const resources = {
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
  fr: {
    translation: translationFR,
  },
  'fr-BE': {
    translation: translationFR_BE,
  },
  nl: {
    translation: translationNL,
  },
  ro: {
    translation: translationRO,
  },
  th: {
    translation: translationTH,
  },
  vi: {
    translation: translationVI,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: { 'fr-BE': ['fr'], default: ['fr'] },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
